const getAssignmentMappingsSubtitle = (assignments) => {
  if (!assignments || !assignments.length) {
    return null;
  }

  if (assignments.length === 1) {
    return 'Composed of 1 assignment';
  }

  return `Composed of ${assignments.length} assignments`;
};

export default getAssignmentMappingsSubtitle;
